import { DataSourcesQueries } from '@frontend/api-data-sources';

export const useGetCustomContactSourceId = () => {
  const { integrations } = DataSourcesQueries.useGetAccessibleIntegrations();

  const customContactSourceId =
    integrations?.find((integration) => integration.SourceType === 'CustomContact')?.SourceID ?? '';

  return { customContactSourceId };
};
